/**
 * Hook para Desbloqueio de Confiança na integração Hubsoft.
 * Abre modal para informar qtd_dias e envia id_cliente_servico + qtd_dias.
 */
import { useCallback, useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { requestDesbloqueioConfiancaHubsoft } from '../services/desbloqueioHubsoft.api';

const TOAST_SUCCESS = {
  title: 'Confiança desbloqueada com sucesso, aguarde o contato do nosso atendimento',
  status: 'success' as const,
  duration: 9000,
  isClosable: true,
};

const TOAST_ERROR = (message: string) => ({
  title: message || 'Erro ao desbloquear confiança',
  status: 'error' as const,
  duration: 9000,
  isClosable: true,
});

export interface UseDesbloqueioHubsoftParams {
  idClienteServico: number | undefined | null;
}

export function useDesbloqueioHubsoft({ idClienteServico }: UseDesbloqueioHubsoftParams) {
  const toast = useToast();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const submitDesbloqueioHubsoft = useCallback(
    async (qtdDias: number) => {
      if (idClienteServico == null || idClienteServico === undefined) {
        toast({
          title: 'Erro ao desbloquear confiança',
          description: 'Contrato não possui id_cliente_servico. Entre em contato com o suporte.',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
        return;
      }

      setIsSubmitting(true);
      try {
        await requestDesbloqueioConfiancaHubsoft(idClienteServico, qtdDias);
        toast(TOAST_SUCCESS);
        closeModal();
      } catch (error: any) {
        toast(TOAST_ERROR(error?.response?.data?.error));
      } finally {
        setIsSubmitting(false);
      }
    },
    [idClienteServico, toast, closeModal]
  );

  return {
    isModalOpen,
    isSubmitting,
    openModal,
    closeModal,
    submitDesbloqueioHubsoft,
  };
}
